<div class="routing-head">
  <div>
    <h4>{{ 'tokenAnalytics.routing.title' | translate }}</h4>
  </div>
  <div class="controls">
    <nb-select size="small" [(selected)]="area" (selectedChange)="rebuild()" [optionsWidth]="220">
      <nb-option value="ALL">{{ 'tokenAnalytics.routing.allAreas' | translate }}</nb-option>
      <nb-option *ngFor="let a of areas" [value]="a">{{ a }}</nb-option>
    </nb-select>
    <nb-checkbox [(checked)]="onlyRoutable" (checkedChange)="rebuild()">
      {{ 'tokenAnalytics.routing.onlyRoutable' | translate }}
    </nb-checkbox>
    <button nbButton size="small" status="basic" (click)="load()" [disabled]="isLoading"
            [nbTooltip]="'tokenAnalytics.routing.reload' | translate">
      <nb-icon icon="refresh-outline"></nb-icon>
    </button>
    <app-page-help>{{ 'tokenAnalytics.routing.subtitle' | translate }}</app-page-help>
  </div>
</div>

<p class="page-hint" *ngIf="loadFailed">{{ 'tokenAnalytics.routing.loadError' | translate }}</p>

<div [nbSpinner]="isLoading" nbSpinnerStatus="primary" *ngIf="data as d">
  <nb-card class="control">
    <nb-card-header>
      <h6><nb-icon icon="power-outline"></nb-icon>{{ 'tokenAnalytics.routing.control.title' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <div class="control-state">
        <span class="tag" [class.tag--ok]="d.control.mode === 'legacy'" [class.tag--switched]="d.control.mode === 'per_task'">
          {{ 'tokenAnalytics.routing.control.mode.' + d.control.mode | translate }}
        </span>
        <span class="tag">{{ 'tokenAnalytics.routing.control.agentLoop.' + d.control.agent_loop | translate }}</span>
        <span class="sub-inline">
          {{ 'tokenAnalytics.routing.control.rev' | translate: { rev: d.control.rev } }}
          <ng-container *ngIf="d.control.updated_at"> · {{ d.control.updated_at | date: 'dd.MM.yyyy HH:mm' }}</ng-container>
          <ng-container *ngIf="d.control.reason"> · {{ d.control.reason }}</ng-container>
        </span>
      </div>
      <p class="page-hint">{{ 'tokenAnalytics.routing.control.hint' | translate }}</p>
      <div class="action-bar">
        <nb-select size="small" [(selected)]="controlMode" [optionsWidth]="260">
          <nb-option value="legacy">{{ 'tokenAnalytics.routing.control.mode.legacy' | translate }}</nb-option>
          <nb-option value="per_task">{{ 'tokenAnalytics.routing.control.mode.per_task' | translate }}</nb-option>
        </nb-select>
        <nb-select size="small" [(selected)]="controlAgentLoop" [optionsWidth]="260">
          <nb-option value="legacy">{{ 'tokenAnalytics.routing.control.agentLoop.legacy' | translate }}</nb-option>
          <nb-option value="opt_in">{{ 'tokenAnalytics.routing.control.agentLoop.opt_in' | translate }}</nb-option>
          <nb-option value="on">{{ 'tokenAnalytics.routing.control.agentLoop.on' | translate }}</nb-option>
        </nb-select>
        <input nbInput size="small" [(ngModel)]="controlReason" maxlength="500" data-enter-ignore
               [placeholder]="'tokenAnalytics.routing.control.reason' | translate" />
        <button nbButton size="small" status="primary" [disabled]="busy" (click)="applyControl()">
          {{ 'tokenAnalytics.routing.control.apply' | translate }}
        </button>
        <button nbButton size="small" status="basic" class="btn-caution" *ngIf="d.control.mode !== 'legacy' || d.control.agent_loop !== 'legacy'"
                [disabled]="busy" (click)="allLegacy()" [nbTooltip]="'tokenAnalytics.routing.control.allLegacyHint' | translate">
          <nb-icon icon="undo-outline"></nb-icon>
          {{ 'tokenAnalytics.routing.control.allLegacy' | translate }}
        </button>
      </div>
      <table class="m-table control-log" *ngIf="d.control.log.length">
        <tbody>
          <tr *ngFor="let l of d.control.log">
            <td class="num">{{ l.changed_at | date: 'dd.MM. HH:mm' }}</td>
            <td>{{ 'tokenAnalytics.routing.control.mode.' + l.mode | translate }}</td>
            <td>{{ 'tokenAnalytics.routing.control.agentLoop.' + l.agent_loop | translate }}</td>
            <td class="num">{{ 'tokenAnalytics.routing.control.rev' | translate: { rev: l.rev } }}</td>
            <td class="muted">{{ l.reason }}</td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-header>
      <h6><nb-icon icon="shuffle-2-outline"></nb-icon>{{ 'tokenAnalytics.routing.tasks' | translate }}</h6>
    </nb-card-header>
    <nb-card-body class="table-body">
      <table class="m-table">
        <thead>
          <tr>
            <th>{{ 'tokenAnalytics.routing.col.task' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.requires' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.model' | translate }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.calls' | translate: { days: d.usage_days } }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.cost' | translate: { days: d.usage_days } }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.perCall' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.status' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of visibleTasks; trackBy: trackTask" class="task-row"
              [class.is-selected]="selected?.task === t.task" (click)="select(t)">
            <td>
              <span class="task-key">{{ t.task }}</span>
              <span class="sub">{{ t.activity === 'overhead' ? ('tokenAnalytics.routing.overhead' | translate) : t.activity }}</span>
            </td>
            <td><span class="cls cls--{{ t.requires }}">{{ t.requires }}</span></td>
            <td>
              <span class="model">{{ t.override && !t.override.pinned_legacy ? t.override.model : t.default_model }}</span>
              <span class="tag tag--switched" *ngIf="t.override && !t.override.pinned_legacy">{{ 'tokenAnalytics.routing.switchedTag' | translate }}</span>
              <span class="tag" *ngIf="t.override?.pinned_legacy">{{ 'tokenAnalytics.routing.pinnedTag' | translate }}</span>
              <span class="tag tag--warn" *ngIf="t.override && !t.override.pinned_legacy && d.control.mode === 'legacy'"
                    [nbTooltip]="'tokenAnalytics.routing.restingHint' | translate">
                {{ 'tokenAnalytics.routing.restingTag' | translate }}
              </span>
              <span class="tag tag--warn" *ngIf="!t.override && t.below_class"
                    [nbTooltip]="'tokenAnalytics.routing.belowClassHint' | translate">
                {{ 'tokenAnalytics.routing.belowClass' | translate }}
              </span>
            </td>
            <td class="num">{{ t.usage ? (t.usage.calls | number) : '—' }}</td>
            <td class="num">{{ t.usage ? usd(t.usage.cost_usd) : '—' }}</td>
            <td class="num">{{ t.usage ? usd(t.cost_per_call_usd[t.override && !t.override.pinned_legacy ? t.override.model : t.default_model] ?? null, 5) : '—' }}</td>
            <td class="status">
              <span *ngIf="t.routable" class="tag tag--ok">{{ 'tokenAnalytics.routing.routable' | translate }}</span>
              <span *ngIf="t.has_eval" class="tag">{{ 'tokenAnalytics.routing.cases' | translate: { n: t.eval_cases } }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="note">{{ 'tokenAnalytics.routing.usageNote' | translate }}</p>
    </nb-card-body>
  </nb-card>

  <nb-card *ngIf="selected as t" class="detail">
    <nb-card-header>
      <h6><nb-icon icon="info-outline"></nb-icon>{{ t.task }}</h6>
    </nb-card-header>
    <nb-card-body>
      <p class="notes">{{ t.notes }}</p>
      <dl class="facts">
        <div><dt>{{ 'tokenAnalytics.routing.fact.where' | translate }}</dt><dd class="mono">{{ t.where }}</dd></div>
        <div><dt>{{ 'tokenAnalytics.routing.fact.needs' | translate }}</dt><dd>{{ t.needs.length ? t.needs.join(', ') : '—' }}</dd></div>
        <div><dt>{{ 'tokenAnalytics.routing.fact.requires' | translate }}</dt><dd>{{ t.requires }} — {{ d.classes[t.requires] }}</dd></div>
        <div *ngIf="t.override as o">
          <dt>{{ 'tokenAnalytics.routing.fact.override' | translate }}</dt>
          <dd>{{ o.model }} · {{ o.updated_at | date: 'dd.MM.yyyy HH:mm' }}<ng-container *ngIf="o.reason"> · {{ o.reason }}</ng-container></dd>
        </div>
      </dl>

      <p class="page-hint" *ngIf="!t.routable">{{ 'tokenAnalytics.routing.notRoutable' | translate }}</p>

      <!-- Candidates for every task: replays compare models on any task;
           the switch buttons stay limited to wired tasks (canSwitch). -->
      <ng-container>
        <table class="m-table candidates">
          <thead>
            <tr>
              <th *ngIf="t.has_eval"></th>
              <th>{{ 'tokenAnalytics.routing.col.model' | translate }}</th>
              <th>{{ 'tokenAnalytics.routing.col.vendor' | translate }}</th>
              <th>{{ 'tokenAnalytics.routing.col.class' | translate }}</th>
              <th class="num">{{ 'tokenAnalytics.routing.col.price' | translate }}</th>
              <th class="num">{{ 'tokenAnalytics.routing.col.perCall' | translate }}</th>
              <th>{{ 'tokenAnalytics.routing.col.eval' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of candidateRows; trackBy: trackModel" [class.is-active]="c.isActive">
              <td *ngIf="t.has_eval" class="pick">
                <nb-checkbox [checked]="evalPick.has(c.model)" (checkedChange)="toggleEval(c.model, $event)"></nb-checkbox>
              </td>
              <td>
                <span class="model">{{ c.model }}</span>
                <span class="tag" *ngIf="c.isDefault">{{ 'tokenAnalytics.routing.default' | translate }}</span>
                <span class="tag tag--switched" *ngIf="c.isActive && !c.isDefault">{{ 'tokenAnalytics.routing.active' | translate }}</span>
              </td>
              <td>{{ c.backend }}</td>
              <td>
                <span class="cls cls--{{ c.klass }}" *ngIf="c.klass">{{ c.klass }}</span>
                <span class="tag tag--warn" *ngIf="classBelow(c.model, t.requires)">{{ 'tokenAnalytics.routing.belowClass' | translate }}</span>
              </td>
              <td class="num">{{ c.price ? (usd(c.price.input) + ' / ' + usd(c.price.output)) : '—' }}</td>
              <td class="num">{{ usd(c.costPerCall, 5) }}</td>
              <td>
                <a *ngIf="c.passedRun as runId" class="link lvl--ok" (click)="openRun(runId)">
                  {{ 'tokenAnalytics.routing.passed' | translate }}
                </a>
                <span *ngIf="!c.passedRun && t.has_eval" class="muted">{{ 'tokenAnalytics.routing.untested' | translate }}</span>
              </td>
              <td class="actions">
                <button nbButton size="tiny" status="primary" *ngIf="c.canSwitch" [disabled]="busy" (click)="switchTo(c)">
                  {{ 'tokenAnalytics.routing.switch' | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="note">{{ 'tokenAnalytics.routing.priceNote' | translate }}</p>

        <section class="cases-block" *ngIf="t.has_eval">
          <div class="cases-head">
            <span>
              <strong>{{ 'tokenAnalytics.routing.casesTitle' | translate }}</strong>
              {{ 'tokenAnalytics.routing.casesCount' | translate: { core: t.eval_case_counts.core, random: t.eval_case_counts.random } }}
            </span>
            <a class="link" (click)="toggleCases()">
              {{ (showCases ? 'tokenAnalytics.routing.casesHide' : 'tokenAnalytics.routing.casesShow') | translate }}
            </a>
          </div>
          <div class="action-bar" *ngIf="t.has_scenarios">
            <nb-select size="small" [(selected)]="genCount">
              <nb-option *ngFor="let n of genCounts" [value]="n">{{ 'tokenAnalytics.routing.genCount' | translate: { n: n } }}</nb-option>
            </nb-select>
            <nb-select size="small" [(selected)]="genSuite">
              <nb-option value="random">{{ 'tokenAnalytics.routing.suite.random' | translate }}</nb-option>
              <nb-option value="core">{{ 'tokenAnalytics.routing.suite.core' | translate }}</nb-option>
            </nb-select>
            <button nbButton size="small" status="basic" [disabled]="busy" (click)="generateCases()"
                    [nbTooltip]="'tokenAnalytics.routing.generateHint' | translate">
              <nb-icon icon="shuffle-outline"></nb-icon>
              {{ 'tokenAnalytics.routing.generate' | translate }}
            </button>
          </div>
          <table class="m-table cases" *ngIf="showCases && cases">
            <tbody>
              <tr *ngFor="let c of cases">
                <td><span class="tag" [class.tag--ok]="c.suite === 'core'">{{ 'tokenAnalytics.routing.suite.' + c.suite | translate }}</span></td>
                <td>{{ c.label }}<span class="sub" *ngIf="c.seed">seed {{ c.seed }} · v{{ c.version }}</span></td>
                <td class="actions">
                  <button nbButton ghost size="tiny" *ngIf="!c.golden" (click)="deactivateCase(c)"
                          [nbTooltip]="'tokenAnalytics.routing.caseRemove' | translate">
                    <nb-icon icon="close-outline"></nb-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!cases.length"><td class="muted">{{ 'tokenAnalytics.routing.casesEmpty' | translate }}</td></tr>
            </tbody>
          </table>
        </section>

        <div class="action-bar">
          <input nbInput size="small" [(ngModel)]="reason" maxlength="500" data-enter-ignore
                 [placeholder]="'tokenAnalytics.routing.reason' | translate" />
          <ng-container *ngIf="caseSets.length">
            <nb-select size="small" [(selected)]="caseSet" [optionsWidth]="240">
              <nb-option *ngFor="let cs of caseSets" [value]="cs">{{ caseSetLabel(cs) }}</nb-option>
            </nb-select>
            <nb-select size="small" [(selected)]="repeats">
              <nb-option *ngFor="let n of [1, 2, 3]" [value]="n">{{ 'tokenAnalytics.routing.repeats' | translate: { n: n } }}</nb-option>
            </nb-select>
            <nb-select size="small" [(selected)]="budgetUsd" [nbTooltip]="'tokenAnalytics.routing.budgetHint' | translate">
              <nb-option *ngFor="let b of budgets" [value]="b">{{ 'tokenAnalytics.routing.budget' | translate: { usd: b } }}</nb-option>
            </nb-select>
            <button nbButton size="small" status="primary" [disabled]="busy || !evalPick.size" (click)="startEval()">
              <nb-icon icon="play-circle-outline"></nb-icon>
              {{ 'tokenAnalytics.routing.startEval' | translate: { n: evalPick.size } }}
            </button>
          </ng-container>
          <button nbButton size="small" status="basic" class="btn-caution" *ngIf="!t.override?.pinned_legacy"
                  [disabled]="busy" (click)="pinLegacy()" [nbTooltip]="'tokenAnalytics.routing.pinLegacyHint' | translate">
            {{ 'tokenAnalytics.routing.pinLegacy' | translate }}
          </button>
          <button nbButton size="small" status="basic" class="btn-caution" *ngIf="t.override" [disabled]="busy" (click)="reset()">
            {{ 'tokenAnalytics.routing.reset' | translate }}
          </button>
        </div>
        <p class="page-hint" *ngIf="!t.has_eval">{{ 'tokenAnalytics.routing.noCases' | translate }}</p>
      </ng-container>

      <ng-container *ngIf="taskRuns.length">
        <h5 class="runs-title">{{ 'tokenAnalytics.routing.runs' | translate }}</h5>
        <table class="m-table">
          <tbody>
            <tr *ngFor="let r of taskRuns; trackBy: trackRun" class="task-row" (click)="openRun(r.id)">
              <td>{{ r.started_at | date: 'dd.MM.yyyy HH:mm' }}</td>
              <td>{{ r.models.join(', ') }}</td>
              <td>× {{ r.repeats }}<span class="sub" *ngIf="r.case_set">{{ caseSetLabel(r.case_set) }}</span></td>
              <td class="num">{{ r.spent_usd !== null && r.spent_usd !== undefined ? usd(r.spent_usd, 3) : '—' }}</td>
              <td>
                <span class="tag" [class.tag--ok]="r.status === 'done'" [class.tag--warn]="r.status === 'failed'">
                  {{ 'tokenAnalytics.routing.status.' + r.status | translate }}
                </span>
              </td>
              <td>{{ r.summary?.cheapest_passing || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </nb-card-body>
  </nb-card>

  <nb-card *ngIf="run as r" class="detail">
    <nb-card-header class="run-head">
      <h6><nb-icon icon="checkmark-square-2-outline"></nb-icon>{{ 'tokenAnalytics.routing.runTitle' | translate: { task: r.task } }}</h6>
      <button nbButton ghost size="small" (click)="closeRun()" [nbTooltip]="'tokenAnalytics.routing.close' | translate">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </nb-card-header>
    <nb-card-body>
      <p class="page-hint" *ngIf="r.status === 'running'">{{ 'tokenAnalytics.routing.running' | translate }}</p>
      <p class="page-hint lvl--crit" *ngIf="r.status === 'failed'">{{ r.error }}</p>
      <p class="page-hint" *ngIf="r.status === 'done' && r.summary?.stopped">{{ r.summary?.stopped }}</p>
      <p class="note" *ngIf="r.spent_usd !== null && r.spent_usd !== undefined">
        {{ 'tokenAnalytics.routing.spent' | translate: { spent: usd(r.spent_usd, 3), budget: usd(r.budget_usd ?? null, 2), set: r.case_set ? caseSetLabel(r.case_set) : '—' } }}
      </p>

      <p class="note" *ngIf="r.summary?.replay">{{ 'tokenAnalytics.routing.replayNote' | translate }}</p>
      <p class="note" *ngIf="r.summary?.langsmith as ls">
        {{ 'tokenAnalytics.routing.langsmithDataset' | translate: { dataset: ls.dataset } }}
        <ng-container *ngFor="let e of experimentList(r)"> · <span class="mono">{{ e.experiment }}</span></ng-container>
        <a *ngIf="data?.langsmith?.base_url as base" class="link" [href]="base" target="_blank" rel="noopener">
          {{ 'tokenAnalytics.routing.openLangsmith' | translate }}
        </a>
      </p>

      <table class="m-table" *ngIf="r.summary as s">
        <thead>
          <tr>
            <th>{{ 'tokenAnalytics.routing.col.model' | translate }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.passRate' | translate }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.score' | translate }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.latency' | translate }}</th>
            <th class="num">p95</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.costCase' | translate }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.errors' | translate }}</th>
            <th class="num" [nbTooltip]="'tokenAnalytics.routing.judgeHint' | translate">{{ 'tokenAnalytics.routing.judgeCol' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of runModels">
            <ng-container *ngIf="s.models[m] as ms">
              <td>
                <span class="model">{{ m }}</span>
                <span class="tag tag--ok" *ngIf="s.cheapest_passing === m">{{ 'tokenAnalytics.routing.cheapest' | translate }}</span>
                <span class="tag" *ngIf="ms.baseline">{{ 'tokenAnalytics.routing.baseline' | translate }}</span>
              </td>
              <td class="num"><span [class.lvl--ok]="ms.passed" [class.lvl--crit]="!ms.passed">{{ ms.pass_rate * 100 | number: '1.0-0' }} %</span></td>
              <td class="num">{{ ms.mean_score | number: '1.2-2' }}</td>
              <td class="num">{{ ms.p50_latency_ms === null ? '—' : ((ms.p50_latency_ms / 1000) | number: '1.1-1') + ' s' }}</td>
              <td class="num">{{ ms.p95_latency_ms == null ? '—' : ((ms.p95_latency_ms / 1000) | number: '1.1-1') + ' s' }}</td>
              <td class="num">{{ usd(ms.avg_cost_usd, 5) }}</td>
              <td class="num">{{ ms.errors }}</td>
              <td class="num">{{ judgeText(ms) }}</td>
              <td>{{ (ms.passed ? 'tokenAnalytics.routing.passed' : 'tokenAnalytics.routing.failed') | translate }}</td>
            </ng-container>
          </tr>
        </tbody>
      </table>
      <p class="note" *ngIf="r.summary">{{ 'tokenAnalytics.routing.threshold' | translate: { pct: (r.threshold * 100 | number: '1.0-0') } }}</p>

      <table class="m-table cases" *ngIf="r.results.length">
        <thead>
          <tr>
            <th>{{ 'tokenAnalytics.routing.col.case' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.model' | translate }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.score' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.note' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.judgeCol' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.output' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let x of r.results">
            <td><span class="task-key">{{ x.case_id }}</span><span class="sub">{{ x.why }}</span></td>
            <td class="model">{{ x.model }}<ng-container *ngIf="r.repeats > 1"> #{{ x.repeat + 1 }}</ng-container></td>
            <td class="num"><span [class.lvl--ok]="x.passed" [class.lvl--crit]="!x.passed">{{ x.score === null ? '—' : (x.score | number: '1.2-2') }}</span></td>
            <td>{{ x.error || x.note }}</td>
            <td>
              <span *ngIf="x.judge?.verdict as v" class="tag" [class.tag--ok]="v === 'better'" [class.tag--warn]="v === 'worse'"
                    [nbTooltip]="x.judge?.reason || ''">{{ 'tokenAnalytics.routing.verdict.' + v | translate }}</span>
            </td>
            <td class="output">{{ x.output }}</td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-header>
      <h6><nb-icon icon="layers-outline"></nb-icon>{{ 'tokenAnalytics.routing.models' | translate }}</h6>
    </nb-card-header>
    <nb-card-body class="table-body">
      <table class="m-table">
        <thead>
          <tr>
            <th>{{ 'tokenAnalytics.routing.col.model' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.vendor' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.class' | translate }}</th>
            <th class="num">{{ 'tokenAnalytics.routing.col.price' | translate }}</th>
            <th>{{ 'tokenAnalytics.routing.col.slots' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of d.models; trackBy: trackModel">
            <td class="model">{{ m.model }}</td>
            <td>{{ m.backend }}</td>
            <td><span class="cls cls--{{ m.class }}" *ngIf="m.class">{{ m.class }}</span></td>
            <td class="num">{{ m.price ? (usd(m.price.input) + ' / ' + usd(m.price.output)) : '—' }}</td>
            <td class="sub-inline">{{ m.slots.join(', ') }}</td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</div>
